module.exports = __webpack_public_path__ + "static/media/shape3_4.f0b187b9.obj";